import React from "react";
import MenuItem from "@/slices-layout/MenuItem";
import CallFill from "atd-icons/dist/CallFill";
import parsePhoneNumber from "libphonenumber-js";
import clsx from "clsx";
import { CgClose } from "react-icons/cg";
import { PrismicNextImage } from "@prismicio/next";
import SearchModal from "@/components/StyledHeader/search-modal";
import SearchOverlayBlock from "@/components/StyledHeader/SearchOverlayBlock";

const MainNavigation = ({
  settings,
  navigation,
  closeMobileMenu,
  mobileMenuOpen = false,
  currentPageUid,
}) => {
  const parsedPhone = parsePhoneNumber(settings.data.phone_number, "US");

  return (
    <div
      className={clsx({
        "bg-[rgba(0,0,0,0.7)] fixed h-screen w-screen ms-auto z-[100] top-0 right-0 xl:static transition-all ease-linear xl:opacity-100 xl:bg-transparent xl:block xl:w-auto xl:h-auto": true,
        "opacity-100 block": mobileMenuOpen,
        "opacity-0 pointer-events-none xl:pointer-events-auto hidden delay-200":
          !mobileMenuOpen,
      })}
      onClick={closeMobileMenu}
    >
      <nav
        className={clsx({
          "max-h-screen overflow-auto xl:overflow-visible bg-black xl:bg-transparent min-h-screen w-[300px] ms-auto transition-transform ease-linear xl:!translate-x-0 xl:w-auto xl:min-h-0 pointer-events-auto": true,
          "translate-x-0 delay-200": mobileMenuOpen,
          "translate-x-full": !mobileMenuOpen,
        })}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex text-white xl:hidden xl:none mb-4">
          <PrismicNextImage
            field={settings?.data.site_logo}
            fallbackAlt={""}
            priority
            loading="eager"
            width={180}
            height={35}
            className={"block object-contain ps-4 pt-4"}
          />
          <button
            onClick={closeMobileMenu}
            className={clsx({
              "p-4 ms-auto": true,
            })}
          >
            <CgClose size={24} />
          </button>
        </div>
        <ul className="flex flex-wrap gap-x-6 xl:gap-x-4 2xl:gap-x-6 p-4 xl:p-0 items-center">
          {navigation?.data?.main_menu?.map((slice, idx) => {
            const isLast = idx === navigation?.data?.main_menu?.length - 1;
            return (
              <MenuItem
                key={slice.id}
                slice={slice}
                isLast={isLast}
                isFirst={!idx}
                currentPageUid={currentPageUid}
              />
            );
          })}
          <SearchModal />

          {!!settings?.data?.phone_number && parsedPhone && (
            <>
              <li
                className={
                  "border-r border-r-[rgba(255,255,255,0.3)] h-[32px] hidden xl:block"
                }
              ></li>
              <li
                className={clsx({
                  "relative text-slate-800 pointer-events-auto main-nav-item text-button py-3 px-4 xl:px-0 mt-3 xl:mt-0": true,
                  "bg-primary xl:bg-transparent": true,
                })}
              >
                <a
                  href={`tel:${parsedPhone.number}`}
                  className={"text-black xl:text-white"}
                >
                  <CallFill
                    size={20}
                    className={"inline-block me-3 mt-[-4px]"}
                  />
                  {settings?.data?.phone_number}
                </a>
              </li>
            </>
          )}
        </ul>
      </nav>
      <SearchOverlayBlock />
    </div>
  );
};

export default MainNavigation;
